import { typographyTokens } from '@/theme/tokens';
import { Box } from '@/ui/primitives';
import { InfoOutlinedIcon } from '@/ui/primitives/icons';
import {
  buildMetricCardTitleSx,
  chartPanelTitleTextSx,
  metricCardTitleInfoIconSx,
} from './chartPanelSurfaceSx';
import { MetricInfoPopoverButton } from './MetricInfoPopoverButton';
import type { ReactElement, ReactNode } from 'react';

type MetricCardTitleProps = {
  children: ReactNode;
  fontSize?: string | { xs?: number; xl?: number };
  infoContent?: ReactNode;
  showInfoIcon?: boolean;
};

const metricCardTitleFontSize = '12px';

export const MetricCardTitle = ({
  children,
  fontSize = metricCardTitleFontSize,
  infoContent,
  showInfoIcon = false,
}: MetricCardTitleProps): ReactElement => (
  <Box
    sx={buildMetricCardTitleSx({ fontSize, fontWeight: typographyTokens.bodyMedium.fontWeight })}
  >
    <Box component="span" sx={chartPanelTitleTextSx}>
      {children}
    </Box>
    {showInfoIcon && infoContent ? (
      <MetricInfoPopoverButton
        ariaLabel={`About ${
          typeof children === 'string' || typeof children === 'number' ? String(children) : 'metric'
        }`}
      >
        {infoContent}
      </MetricInfoPopoverButton>
    ) : showInfoIcon ? (
      <InfoOutlinedIcon sx={metricCardTitleInfoIconSx} />
    ) : null}
  </Box>
);
